import { FunctionComponent, useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import classnames from 'classnames';

import { LocalStorageKeys as StorageKeys } from 'types/localeStorage';

import { parseToQueryString } from 'utils/querystring';

import Button from 'components/layout/Button';
import Pagination from 'components/layout/Pagination';
import Spinner, { Positions } from 'components/layout/Spinner';
import ResultsListElement from 'components/modules/public/layout/jobs/ResultsListElement';

import { Props } from './index';
import StyledComponent from './styles';

const PublicLayoutJobsResultsList: FunctionComponent<Props> = ({
    collection,
    buttonProps,
    onSaveJobFavourites,
    onSaveJobSearchQuery,
    onClearFilters,
    hasActiveFilters,
    savedSearch,
    translations,
    onChangePage,
    isLoaded,
    profile,
}) => {
    const [visitedOffers, setVisitedOffers] = useState([]);

    const router = useRouter();

    useEffect(() => {
        const storageVisitedOffers = JSON.parse(localStorage.getItem(StorageKeys.VisitedOffers));
        setVisitedOffers(storageVisitedOffers);
    }, []);

    return (
        <>
            <StyledComponent className="public-layout-jobs-results-list">

                {Array.isArray(collection?.elements) && collection.elements.map(element => (
                    <>
                        {element.jobCities && element.jobCities.map(jobCity => (
                            <article
                                className={classnames(
                                    'job-result',
                                    { 'visited': visitedOffers?.findIndex((offer)=>offer === element.id + jobCity?.id) >= 0 }
                                )}
                                key={jobCity.id}
                                id={element?.slug}
                            >
                                <ResultsListElement
                                    job={element}
                                    jobCity={jobCity}
                                    buttonProps={buttonProps}
                                    onSaveJobFavourites={onSaveJobFavourites}
                                    userEmail={profile?.email || null}
                                />
                            </article>
                        ))}
                    </>
                ))}

                {collection.elements.length <= 0 && isLoaded && !collection.isLoading && (
                    <div className="collection-zero-state">
                        <div
                            className="zero-state-title"
                            dangerouslySetInnerHTML={{ __html: translations?.zeroState?.title }}
                        />
                        <div
                            className="zero-state-subtitle"
                            dangerouslySetInnerHTML={{ __html: translations?.zeroState?.subtitle }}
                        />
                        {hasActiveFilters && (
                            <Button
                                className="zero-state-clear-filters-button"
                                onClick={onClearFilters}
                            >
                                {translations?.zeroState?.titleClearFiltersButton}
                            </Button>
                        )}
                        <Button
                            className="zero-state-save-button"
                            onClick={onSaveJobSearchQuery}
                        >
                            {savedSearch ? translations?.zeroState?.titleSavedButton : translations?.zeroState?.titleSaveButton}
                        </Button>
                    </div>
                )}
            </StyledComponent>
            {collection?.meta && collection.elements.length > 0 && (

                <Pagination
                    currentPage={collection.meta.currentPage}
                    lastPage={collection.meta.lastPage}

                    hrefBuilder={(currentPage) => {
                        const urlSearchParams = new URLSearchParams;
                        const { ...queryParams }: any = router.query;

                        Object.keys(router.query)
                            .map( key => urlSearchParams.set(key, queryParams[ key ]) );


                        if (currentPage == 1) urlSearchParams.delete('page');
                        else urlSearchParams.set('page', currentPage.toString() );
                        return '/oferty-pracy/?' + urlSearchParams.toString();
                    }}

                    onPageChange={(nextPage: number) => {
                        if (nextPage === collection?.meta?.currentPage) return;
                        onChangePage(nextPage);
                    }}
                />
            )}
        </>
    );
};

export default PublicLayoutJobsResultsList;